// extracted by mini-css-extract-plugin
export default {"container":"BonusesSectionToggle_container--Hth","button":"BonusesSectionToggle_button--CTM","counterContainer":"BonusesSectionToggle_counterContainer--NmO"};